import { ApplicationConfig,importProvidersFrom  } from '@angular/core';
import { provideRouter } from '@angular/router';
import { RecaptchaV3Module, RECAPTCHA_V3_SITE_KEY } from 'ng-recaptcha';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { routes } from './app.routes';
import { provideHttpClient } from '@angular/common/http';
export const appConfig: ApplicationConfig = {
  providers: [provideHttpClient(),provideRouter(routes) ,  importProvidersFrom(RecaptchaV3Module,BrowserAnimationsModule) ,{
      provide: RECAPTCHA_V3_SITE_KEY,useValue: "6Lemw7spAAAAAIWK1jzeBI9gyupalNNkW5Fmf2Ab"}]
};
